<template>
  <div id="news">
    <div class="general-header container">
      <h3 class="cate-title">技术论坛</h3>
      <div class="visible-xs" style="clear:both;"></div>

      <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item >技术论坛</el-breadcrumb-item>
            </el-breadcrumb>
    </div>
    <div class="news container">
      <ul class="news-list">
        <li class="news-item" v-for="item in newsList" :key="item.id" @click="jumpDetail(item.id)">
          <span class="el-icon-arrow-right"></span>
          {{item.name}}
          <span class="news-data">{{item.data}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Daily from '../../assets/data/plan.js';

  export default {
    name: "plan",
    data(){
      return{
        kind:'',
        newsList:[],
      }
    },
    created() {
      this.newsList = Daily.plan;
    },

    methods:{
      jumpDetail(id){
        this.$router.push({
          name: 'plan-detail',
          params:{
            id:id
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #news{
    .general-header{
      border-bottom: 1px solid #dddddd;
      padding: 31px 0;
      .cate-title{
        padding: 0 10px;
        display: inline-block;
        width: 190px;
        margin:0;

      }
      .el-breadcrumb{
        padding: 0 10px;
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .news{
      padding: 20px;
      .news-list{
        height: 500px;
        overflow: auto;
        .news-item{
          margin-bottom: 12px;
          &:hover{
            color:#004ca0;
            cursor: pointer;
          }
          .news-data{
            float: right;
            color: #999999;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/plan.vue